import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const configurationRoutes: RouteObject[] = [
  {
    path: '/configuration/view/:configId',
    element: lazyElement(() => import('./ConfigurationViewPage')),
    handle: {
      documentTitle: 'Configuration',
      crumb: () => ({ label: 'Configuration' })
    },
  },
];

export default configurationRoutes;
